import {
    Avatar,
    Card,
    CardContent,
    Grid,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Typography,
  } from "@mui/material";
  import { Box, Container } from "@mui/system";
  import React, { useEffect, useState } from "react";
  import { aadhar3, aboutUs, DMT, office, stationery, tick } from "../iconsImports";
  import { getEnv, primaryColor } from "../theme/setThemeColor";
  import ContactsOutlinedIcon from "@mui/icons-material/ContactsOutlined";
  import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
  import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
  import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
  import LockClockOutlinedIcon from "@mui/icons-material/LockClockOutlined";
  import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
  import SecurityIcon from "@mui/icons-material/Security";
  import ShutterSpeedIcon from "@mui/icons-material/ShutterSpeed";
  import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
  import about_Us from "../assets/growth1.jpg";
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
  const mWhyChooseUs = [
    {
      title: "User-friendly platorm",
      body: "Our digital banking platform is designed with simplicity and ease of use in mind. We prioritise user experience and strive to create an intuitive interface that makes banking convenient and accessible.",
      icon: <PeopleAltOutlinedIcon />,
    },
    {
      title: "Minimum Investment",
      body: "Unlock financial opportunities with our platform requiring minimal investment. Our platform offers the flexibility to start investing with a low minimum investment, allowing you to take advantage of various investment options and grow your wealth. Experience the power of growing your wealth with even the smallest amounts.",
      icon: <TrendingUpOutlinedIcon />,
    },
  
    {
      title: "Quick Onboarding",
      body: "Experience hassle-free onboarding with us! Our streamlined process ensures quick and efficient account setup, allowing you to start enjoying our services in no time.",
      icon: <ContactsOutlinedIcon />,
    },
    {
      title: "Dedicated Merchant Support",
      body: "We prioritise customer satisfaction and offer exceptional support whenever you need it. Our dedicated merchant/customer support team is just a call or message away, and ready to assist you with any questions or concerns.",
      icon: <HandshakeOutlinedIcon />,
    },
    {
      title: "Safe & Secure Transactions",
      body: "We prioritise the security of our customers' financial information and adhere to strict compliance standards. With our robust security measures, you can trust that your transactions are confidential, protected, and carried out with integrity. Your peace of mind is our utmost priority.",
  
      icon: <LockClockOutlinedIcon />,
    },
    {
      title: "Multiple Banking Services",
      body: "We offer a wide range of digital banking services, including online banking, mobile banking, savings and checking accounts, insurance, and more. Our aim is to provide a comprehensive suite of services that cater to the diverse financial needs of our customers.",
      icon: <AccountBalanceOutlinedIcon />,
    },
  ];
  const LandingPageAeeps = () => {
    const envName = getEnv();
  
    const [isMounted, setIsMounted] = useState(false);
    useEffect(() => {
      // 👇️ scroll to top on page load
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, []);
    useEffect(() => {
      setIsMounted(true); // Trigger the fade-in effect when the component mounts
    }, []);
    return (
      <div id="about-us " className="aboutUs">
        <Grid container >
          {/* about us */}
          <div className="AepsPageBg">{/* <img src={} alt="" /> */}</div>
          <div className="textContainer">
          <Typography style={{ fontSize: "20px", fontWeight: "bold" ,textAlign:"justify" }}>
            {/* This is the problem {getEnv()} was built to address. */}
            <b> {getEnv()} </b>
            is established by a team of professionals with decades of experience
            in the BFSI industry, {getEnv()} focuses on developing insights into
            the deep market potential of the financial transaction and financial
            technology space in India. We aim to lead this pool of persevering
            small-scale entrepreneurs into a financially inclusive, financially
            stronger future.
          </Typography>
        </div>
          {/* the about us image */}
          {envName !== "MoneyOddr" && (
            <Grid md={12} container>
              <Grid md={6} sx={{ mb: { md: 0, xs: 5 } }}>
                <img src={aadhar3} width="90%" alt="About us img" />
              </Grid>
              <Grid
  md={6}
  container
  sx={{
    mt: { md: 5, xs: 5 },
    
    display: "flex",
    flexDirection: "column", 
        justifyContent: "center",
    alignItems: "left", 
    textAlign: "center",   
    padding: 2, 
  }}
>
  <Typography variant="h3" sx={{  fontWeight: 'bold' ,textAlign:"left",}}>
    DilliPay's
  </Typography>
  <Typography variant="h4" sx={{  fontWeight: 'bold',textAlign:"left" }}>
  Aadhaar Enabled Payment System
  </Typography>
  <Typography sx={{ mt: 2, fontSize: "18px", maxWidth: '650px',textAlign:"justify" }}>
  DilliPay offers a seamless and secure Aadhaar Enabled Payment System (AEPS) service that allows customers to perform financial transactions using their Aadhaar number. 
  AEPS is a government-backed initiative that enables individuals to access banking services directly through their Aadhaar-linked bank accounts, without the need for a debit card or physical bank visit.
  </Typography>
  <Typography sx={{ mt: 2, fontSize: "18px", maxWidth: '650px',textAlign:"justify" }}>
  Through DilliPay’s AEPS service, users can carry out various transactions like cash deposits, withdrawals, balance inquiries, and fund transfers.
  By integrating AEPS, DilliPay aims to bring financial empowerment to people, ensuring smooth and efficient transactions while maintaining the highest standards of security and convenience.
  </Typography>
</Grid>

            </Grid>
          )}
        </Grid>
{/*     
<Box
className="servicePageBg3"
  sx={{
    // backgroundColor: "#E5E5E5",
    // backgroundImage: `url(${office})`,
    // color: "white",
    // background:"cover",
    // textAlign: "center",
    // py: 6,
    // borderRadius: 2,
    // boxShadow: "0 8px 16px rgba(0, 0, 0, 0.15)",
    // transition: "all 0.3s ease",
    // "&:hover": { transform: "scale(1.03)" },
  }}
>
  <Typography
    variant="1"
    sx={{
      px: 4,
      justifyContent: "center",
      display: "flex",
      fontFamily: "'Poppins', sans-serif",
      fontSize: { xs: "1.125rem", sm: "1.25rem", lg: "2.5rem" },
      color: "#000",
    }}
  >
    Benefits of becoming
  </Typography>
  <Typography
    variant="1"
    sx={{
      px: 4,
      justifyContent: "center",
      display: "flex",
      fontFamily: "'Poppins', sans-serif",
      fontSize: { xs: "1.125rem", sm: "1.25rem", lg: "2.5rem" },
      fontWeight: "bold",
      color: "#000",
    }}
  >
    Dillipay's DMT Service Provider
  </Typography>
  
  {/* Map through the array of benefits */}
  {/* <Box
    sx={{
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      mt: 4,
      justifyContent: "center",
      gap: 5,
    }}
  >
    {[
      { title: "Fast and Secure Transactions", color: "#fff", imageSrc: office},
      { title: "Real-Time Transaction", color: "#fff", imageSrc: office},
      { title: "Attractive Commission", color: "#fff", imageSrc: office},
      { title: "Money transfer available 365 days", color: "#fff", imageSrc: office},
      { title: "Money transfer available 365 days", color: "#fff", imageSrc: office}
    ].map((benefit, index) => (
      <Box
        key={index}
        sx={{
          width: 250,
          height: 250,
          borderRadius: "50%",
          backgroundColor: benefit.color,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
        }}
      >
        {/* Image inside the circle */}
{/*      
          <img
            src={benefit.imageSrc}
            alt={benefit.title}
            style={{
              width: "40%",
              height: "40%",
              objectFit: "cover", // Ensures the image covers the circle area
            }}
          /> */}
        {/* Text below the image */}
        {/* <Typography
          sx={{
            fontSize: { xs: "1rem", sm: "1.125rem" },
            color: "black",
            textAlign: "center",
          }}
        >
          {benefit.title}
        </Typography>
      </Box>
    ))}
  </Box>  */}
{/* // </Box>  */}
          {/* what we do */}
          <div className="builSecurity_bg">
            <Container maxWidth="lg" sx={{ mt: 10 }} className="bottom2top">
              <div className="landingPageHeadings ">
                {/* {envName === "MoneyOddr" ? "Why Choose Us" : "What We Do"} */}
                <h1>    Benefits of becoming Dillipay's Aeps Service Provider

                </h1>
              </div>
  
              {envName === "MoneyOddr" ? (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      my: 5,
                    }}
                  >
                    <Typography variant="h4" sx={{ fontWeight: "600" }}>
                      Attractive Commision
                    </Typography>
                    <Typography variant="body">
                      Maximise Your Income with our Irresistible & Best Commission
                      Rates!
                    </Typography>
                  </Box>
                  <Grid container>
                    {mWhyChooseUs &&
                      mWhyChooseUs.map((item) => {
                        return (
                          <Grid
                            lg={6}
                            md={6}
                            sm={12}
                            xs={12}
                            sx={{
                              mt: { lg: 2, md: 2, sm: 3, xs: 3 },
                              px: { lg: 1, md: 1, sm: 0, xs: 0 },
                            }}
                          >
                            <List
                              sx={{
                                width: "100%",
  
                                bgcolor: "background.paper",
                                position: "relative",
                              }}
                            >
                              <ListItem>
                                <ListItemAvatar
                                  sx={{
                                    position: "absolute",
                                    // left: "-30px",
                                    top: 20,
                                  }}
                                >
                                  <Avatar sx={{ backgroundColor: "#0096DD" }}>
                                    {item.icon}
                                  </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                  sx={{ ml: 8 }}
                                  primary={
                                    <Typography
                                      variant="h4"
                                      sx={{ fontWeight: "600" }}
                                    >
                                      {item.title}
                                    </Typography>
                                  }
                                  secondary={
                                    <Typography
                                      variant="body"
                                      sx={{
                                        display: "flex",
                                        textAlign: "justify",
                                      }}
                                    >
                                      {item.body}
                                    </Typography>
                                  }
                                />
                              </ListItem>
                            </List>
                          </Grid>
                        );
                      })}
                  </Grid>
                </>
              ) : (
                <>
                  <Container maxWidth="lg" sx={{ mt: 10 }}>
                    <Grid
                      container
                      spacing={2}
                      alignItems="center"
                      justifyContent="center"
                      sx={{
                        opacity: isMounted ? 1 : 0,
                        animation: isMounted ? "fadeIn 1s ease-in-out" : "none",
                      }}
                    >
                      <Grid
                        item
                        container
                        xs={12}
                        sm={6}
                        md={3}
                        direction="column"
                        spacing={2}
                        sx={{
                          mr: 10,
                        }}
                      >
                        <Grid item>
                          <Card
                            sx={{
                              width: "300px",
                              height: "270px",
                              margin: "10px",
                              textAlign: "center",
                              backgroundColor: "#e0f2f1",
                              borderRadius: "16px",
                              boxShadow: "0px 4px 20px rgba(0, 128, 0, 0.2)",
                              transition:
                                "transform 0.3s ease, box-shadow 0.3s ease",
                              "&:hover": {
                                transform: "scale(1.05)",
                                boxShadow: "0px 6px 25px rgba(0, 128, 0, 0.3)",
                              },
                            }}
                          >
                            <CardContent>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "flex-end",
                                  alignItems: "flex-end",
                                }}
                              >
                                {/* Innovation Icon aligned to the right */}
                                <RocketLaunchIcon
                                  sx={{
                                    fontSize: "45px",
                                    color: "#1b5e20",
                                    marginBottom: "10px",
                                  }}
                                />
                                <Typography
                                  variant="h4"
                                  sx={{
                                    color: "#1b5e20",
                                    fontWeight: "bold",
                                    textAlign: "right",
                                  }}
                                >
Interface 
                                 </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    textAlign: "right",
                                    fontSize: "20px",
                                  }}
                                >
DilliPay provides a simple, intuitive, and easy-to-use platform for retailers
                                </Typography>
                              </Box>
                            </CardContent>
                          </Card>
                        </Grid>
                        <Grid item>
                          <Card
                            sx={{
                              width: "300px",
                              height: "270px",
                              margin: "10px",
                              textAlign: "center",
                              backgroundColor: "#e0f2f1",
                              borderRadius: "16px",
                              boxShadow: "0px 4px 20px rgba(0, 128, 0, 0.2)",
                              transition:
                                "transform 0.3s ease, box-shadow 0.3s ease",
                              "&:hover": {
                                transform: "scale(1.05)",
                                boxShadow: "0px 6px 25px rgba(0, 128, 0, 0.3)",
                              },
                            }}
                          >
                            <CardContent>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "flex-end",
                                  alignItems: "flex-end",
                                }}
                              >
                                <ShutterSpeedIcon
                                  sx={{
                                    fontSize: "45px",
                                    color: "#1b5e20",
                                    marginBottom: "10px",
                                  }}
                                />
                                <Typography
                                  variant="h4"
                                  sx={{
                                    color: "#1b5e20",
                                    fontWeight: "bold",
                                    textAlign: { lg: "right", sm: "center" },
                                  }}
                                >
                                   Commission
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontSize: "20px",
                                    textAlign: { lg: "right", sm: "center" },
                                  }}
                                >
 DilliPay offers competitive and attractive commission structures for each AEPS transaction.
        </Typography>
                              </Box>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
  
                      {/* Center: 1 card */}
                      <Grid item xs={12} sm={6} md={3}>
                        <Card
                          sx={{
                            width: "300px",
                            height: "350px",
                            margin: "10px",
                            textAlign: "center",
                            alignItems: "center",
                            // backgroundColor: "#71C1DC",
                            borderRadius: "16px",
                            // background: "#71C1DC",
                            boxShadow: "0px 4px 20px rgba(0, 128, 0, 0.2)",
                            transition:
                              "transform 0.3s ease, box-shadow 0.3s ease",
                            "&:hover": {
                              transform: "scale(1.05)",
                              boxShadow: "0px 6px 25px rgba(0, 128, 0, 0.3)",
                            },
                          }}
                        >
                          <CardContent>
                            <img
                              src={about_Us}
                              alt="img"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          </CardContent>
                        </Card>
                      </Grid>
  
                      <Grid
                        item
                        container
                        xs={12}
                        sm={6}
                        md={3}
                        direction="column"
                        spacing={2}
                        sx={{
                          ml: 10,
                        }}
                      >
                        <Grid item>
                          <Card
                            sx={{
                              width: "300px",
                              height: "270px",
                              margin: "10px",
                              textAlign: "center",
                              backgroundColor: "#e8f5e9",
                              borderRadius: "16px",
                              boxShadow: "0px 4px 20px rgba(0, 128, 0, 0.2)",
                              transition:
                                "transform 0.3s ease, box-shadow 0.3s ease",
                              "&:hover": {
                                transform: "scale(1.05)",
                                boxShadow: "0px 6px 25px rgba(0, 128, 0, 0.3)",
                              },
                            }}
                          >
                            <CardContent>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "flex-start",
                                  alignItems: "flex-start",
                                }}
                              >
                                <IntegrationInstructionsIcon
                                  sx={{
                                    fontSize: "45px",
                                    color: "#1b5e20",
                                    marginBottom: "10px",
                                  }}
                                />
                                <Typography
                                  variant="h4"
                                  sx={{
                                    color: "#1b5e20",
                                    fontWeight: "bold",
                                    textAlign: { lg: "left", sm: "center" },
                                  }}
                                >
                                  Quick Settlement 
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontSize: "20px",
                                    textAlign: { lg: "left", sm: "center" },
                                  }}
                                >
Retailers prefer DilliPay because it offers quick settlements for the transactions processed.
                                </Typography>
                              </Box>
                            </CardContent>
                          </Card>
                        </Grid>
                        <Grid item>
                          <Card
                            sx={{
                              width: "300px",
                              height: "270px",
                              margin: "10px",
                              textAlign: "center",
                              backgroundColor: "#e8f5e9",
                              borderRadius: "16px",
                              boxShadow: "0px 4px 20px rgba(0, 128, 0, 0.2)",
                              transition:
                                "transform 0.3s ease, box-shadow 0.3s ease",
                              "&:hover": {
                                transform: "scale(1.05)",
                                boxShadow: "0px 6px 25px rgba(0, 128, 0, 0.3)",
                              },
                            }}
                          >
                            <CardContent>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "flex-start",
                                  alignItems: "flex-start",
                                }}
                              >
                                <SecurityIcon
                                  sx={{
                                    fontSize: "45px",
                                    color: "#1b5e20",
                                    marginBottom: "10px",
                                  }}
                                />
                                <Typography
                                  variant="h4"
                                  sx={{
                                    color: "#1b5e20",
                                    fontWeight: "bold",
                                    textAlign: { lg: "left", sm: "center" },
                                  }}
                                >
                                  Security
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontSize: "20px",
                                    textAlign: { lg: "left", sm: "center" },
                                  }}
                                >
DilliPay ensures that all transactions are secure, providing a transparent, error-free service.     
                            </Typography>
                              </Box>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Container>
                </>
              )}    
            </Container>
          </div>
      </div>
    );
  };
  
  export default LandingPageAeeps;
  